import React from "react";
import "./Dpu_Learn_Ai_Tool_Swiper.css";
import Main_heading_holder from "../../common_components/main_heading_holder/Main_heading_holder";

const Dpu_Learn_Ai_Tool_Swiper = () => {
  const data = [
    "/assets/images/dpu_mca/ai_tools/butterfly.png",
    "/assets/images/dpu_mca/ai_tools/chiefex.png",
    "/assets/images/dpu_mca/ai_tools/dyninno.png",
    "/assets/images/dpu_mca/ai_tools/eclerx.png",
    "/assets/images/dpu_mca/ai_tools/genpact.png",
    "/assets/images/dpu_mca/ai_tools/hcl.png",
    "/assets/images/dpu_mca/ai_tools/mahindra.png",
    "/assets/images/dpu_mca/ai_tools/minfy.png",
    "/assets/images/dpu_mca/ai_tools/jabil.png",
    "/assets/images/dpu_mca/ai_tools/grapcity.png",
    "/assets/images/dpu_mca/ai_tools/1.webp",
    "/assets/images/dpu_mca/ai_tools/2.webp",
    "/assets/images/dpu_mca/ai_tools/3.webp",
    "/assets/images/dpu_mca/ai_tools/4.webp",
    "/assets/images/dpu_mca/ai_tools/6.webp",
    "/assets/images/dpu_mca/ai_tools/7.webp",
    "/assets/images/dpu_mca/ai_tools/8.webp",
    "/assets/images/dpu_mca/ai_tools/9.webp",
    "/assets/images/dpu_mca/ai_tools/10.webp",
    "/assets/images/dpu_mca/ai_tools/11.webp",
    "/assets/images/dpu_mca/ai_tools/13.webp",
    "/assets/images/dpu_mca/ai_tools/14.webp",
    "/assets/images/dpu_mca/ai_tools/15.webp",
    "/assets/images/dpu_mca/ai_tools/16.webp",
  ];

  return (
    <section className="Dpu_Learn_Ai_Tool_Swiper">
      <div className="container">
        <Main_heading_holder
          heading="Our"
          spanHeading=" Associates / Recruiters"
          headingType="h2"
        />

        <div className="logo-grid">
          {data.map((item, index) => (
            <div className="logo-card" key={index}>
              <img
                src={item}
                alt={`Recruiter ${index + 1}`}
                loading="lazy"
                className="logo-image"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Dpu_Learn_Ai_Tool_Swiper;
